import type { ApprovalOperation } from 'ui-product-approvals-common';

import { isNoteOperation } from './approvalNoteOperation';

interface ShowsNestedPanelArgs {
  isNestedPanelGateOn: boolean;
  showModal: boolean;
  currentOperation: ApprovalOperation | null;
  currentStepId: number | null;
  hasSidebar: boolean;
}

export const getShowsNestedPanel = ({
  isNestedPanelGateOn,
  showModal,
  currentOperation,
  currentStepId,
  hasSidebar,
}: ShowsNestedPanelArgs) =>
  isNestedPanelGateOn &&
  showModal &&
  isNoteOperation(currentOperation) &&
  currentStepId !== null &&
  hasSidebar;
